import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LibrarySkill } from '../../../services/skill.service';

/**
 * One skill from the library or from a pasted GitHub link: name, description,
 * license and "needs code" badges, a link to the source — and either an
 * import button or (in the link dialog) a checkbox. A skill whose license does
 * not allow copying it shows why instead of an enabled action.
 */
@Component({
  selector: 'app-library-skill-item',
  templateUrl: './library-skill-item.component.html',
  styleUrl: './library-skill-item.component.scss',
})
export class LibrarySkillItemComponent {
  @Input({ required: true }) skill!: LibrarySkill;
  /** label of the source (library) — omitted for a pasted link */
  @Input() sourceLabel: string | null = null;
  /** 'button' = import button, 'checkbox' = selectable */
  @Input() mode: 'button' | 'checkbox' = 'button';
  @Input() busy = false;
  @Input() checked = false;
  @Output() importClick = new EventEmitter<LibrarySkill>();
  @Output() checkedChange = new EventEmitter<boolean>();
}
